const SET = 'serverLocationPath/SET'

interface Ctx {
  path: string
  querystring: string
  __originqQueryString__: string
}

export const setServerLocationPath = (ctx: Ctx) => {
  let queryString = ctx.__originqQueryString__ || ctx.querystring
  queryString = queryString && `?${queryString}`
  // koa context.url 에는 url 중 hash 값이 포함되지 않음
  return {
    locationPath: ctx.path + queryString,
    type: SET,
  }
}

export default (state = '', action) => {
  switch (action.type) {
    case SET:
      return action.locationPath
    default:
      return state
  }
}
